import React from "react";
import { render } from "react-dom";
import { Provider, observer } from "mobx-react";
import store from "./stores/store";
import { HashRouter, Route } from "react-router-dom";
import Map from "./components/Map";
import "./styles/index.scss";
import "pepjs";

const stores = { store };
@observer
class ReactApp extends React.Component {
  componentDidMount() {
    store.preloadImages();
  }

  render() {
    return (
      <Provider {...stores}>
        <HashRouter hashType="noslash">
          <Route path="*" component={Map} />
        </HashRouter>
      </Provider>
    );
  }
}

render(<ReactApp />, document.getElementById("cityMap"));
